// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"7ca3e366","85":"80b36fde","90":"7ca3e366","317":"78fc4dec","486":"7ca3e366","562":"80b36fde","867":"7ca3e366","914":"cd5f5ef9"}[chunkId] + ".css";
};